import { Box } from "@mui/material"

const IMAGEM_COLORIDA = /\.(png|jpe?g|webp)(\?.*)?$/i

export function ehImagemColorida(src: string): boolean {
    return IMAGEM_COLORIDA.test(src)
}

interface IconeCategoriaProps {
    src: string
    cor: string
    tamanho?: number
}

export default function IconeCategoria({ src, cor, tamanho = 50 }: IconeCategoriaProps): JSX.Element {
    if (ehImagemColorida(src)) {
        return (
            <Box
                component="img"
                src={src}
                alt=""
                aria-hidden
                sx={{ width: tamanho, height: tamanho, flexShrink: 0, objectFit: 'contain' }}
            />
        )
    }

    return (
        <Box
            aria-hidden
            sx={{
                width: tamanho,
                height: tamanho,
                flexShrink: 0,
                backgroundColor: cor,
                WebkitMaskImage: `url("${src}")`,
                maskImage: `url("${src}")`,
                WebkitMaskRepeat: 'no-repeat',
                maskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
                maskPosition: 'center',
                WebkitMaskSize: 'contain',
                maskSize: 'contain',
            }}
        />
    )
}
